module.exports = __webpack_public_path__ + "static/media/maja.b090f593.jpg";